/* CompactAppCard.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["alt", "loading", "src"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _23 = "._p12f18bf{max-width:8.25rem}";
const _22 = "._18u0idpf{margin-left:0}";
const _21 = "._otyridpf{margin-bottom:0}";
const _20 = "._2hwxidpf{margin-right:0}";
const _19 = "._19pkidpf{margin-top:0}";
const _18 = "._1n261g80{flex-wrap:wrap}";
const _17 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _16 = "._11q7hp5a{background:var(--ds-surface-raised,#fff)}";
const _15 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
const _14 = "._1yt4pxbi{padding:var(--ds-space-200,1pc)}";
const _13 = "._19itpp12{border:var(--_18x9sjc)}";
const _12 = "._2rko1j6v{border-radius:1rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const _11 = "._4t3i8pqr{height:2.5rem}";
const _10 = "._1bsb8pqr{width:2.5rem}";
const _9 = "@media not all and (min-width:64rem){._1s4pqf5o{width:3.25rem}._1kneqf5o{height:3.25rem}}";
const _8 = "._syazbku0{color:var(--ds-icon-brand,#0c66e4)}";
const _7 = "._4t3i1b9w{height:3.75rem}";
const _6 = "._1bsb1b9w{width:3.75rem}";
const _5 = "._t9ec11c6{transform:scale(2.2)}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._1bah1h6o{justify-content:center}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._2rkoebcm{border-radius:.375rem}";
import AppIcon from '@atlaskit/icon/core/app';
import { media } from '@atlaskit/primitives';
import { BodySmall } from '@atlassian/mpac-primitives';
import { useState } from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const BundleAppsItem = null;
const AppLogoStyle = null;
const AddOnIconCover = null;
function AppLogo(_ref) {
  let {
      alt,
      loading,
      src
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [imgLoadError, setImgLoadError] = useState(false);
  function onError() {
    setImgLoadError(true);
  }
  if (imgLoadError) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_2rkoebcm _1e0c1txw _1bah1h6o _4cvr1h6o _t9ec11c6 _1bsb1b9w _4t3i1b9w _syazbku0 _1s4pqf5o _1kneqf5o"]),
        children: /*#__PURE__*/_jsx(AppIcon, {
          label: ""
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _10, _11, _9]
    }), /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({
      alt: alt,
      loading: loading,
      src: src
    }, props), {}, {
      onError: onError,
      className: ax(["_2rkoebcm _1bsb8pqr _4t3i8pqr _1s4pqf5o _1kneqf5o"])
    }))]
  });
}
export const CompactAppCard = () => {
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14, _15, _16, _17, _2, _18]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_2rko1j6v _19itpp12 _1yt4pxbi _zulppxbi _11q7hp5a _1bsb1ns9 _1e0c1txw _1n261g80"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: [/*#__PURE__*/_jsx(AppLogo, {
        alt: "Metrics for sprints in JIRA",
        loading: "lazy",
        src: "https://placehold.co/200",
        "aria-hidden": "true"
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_19, _20, _21, _22, _23]
        }), /*#__PURE__*/_jsx(BodySmall, {
          className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _p12f18bf"]),
          children: "Metrics for sprints in JIRA"
        })]
      })]
    })]
  });
};